<template>
  <v-card v-if="hideSection" class="mt-3">
    <v-card-title>
      <span>{{sectionLabel}}</span>
    </v-card-title>
    <v-card-text class="p-n">
      <v-row dense class="mb-3 flex" v-if="!isDataValidation">
        <v-col cols="12" class="mb-3 ml-3">
          <div class="text13 pull-left">In the past four years, were you in another country (other than Canada) for a total of 183 days or more?</div>
          <el-radio-group class="ml-3 mt-1 pull-left" @change="checkCitizenship()" v-model="form.another_country">
            <el-radio label="No">No</el-radio>
            <el-radio label="Yes">Yes</el-radio>
          </el-radio-group>
        </v-col>
      </v-row>
      <v-alert type="info" border="left" dense class="mb-3" v-if="sectionInfoBox">
        {{sectionInfoBox}}
      </v-alert>
      <p v-if="form.another_country === 'Yes'">
        If yes, list each country in the chart below. You must provide a police certificate for each country where you have been present for 183 days or more. If you cannot get a police certificate, tell us why below.
      </p>
      <table class="table" style="width:100%" v-if="form.another_country === 'Yes'">
        <thead>
          <tr>
            <th width="250">Country</th>
            <th>Explanation</th>
            <th width="30">
              <v-btn color="green" small fab @click.native="saveForm()">
                <v-icon class="white--text">add</v-icon>
              </v-btn>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(form,i) in items" :key="i" :id="'row' + form.id">
            <td class="pa-1">
              <div v-if="dataValidationItems(form, 'country')" class="el-select native-select">
                <div class="el-input">
                  <select v-model="form.country" placeholder="Select" class="el-input__inner" @change="handleAutoSave(i, form)">
                    <option v-for="(item, index) in country" v-bind:key="index" :value="item.id" :label="item.country_name">{{ item.country_name }}</option>
                  </select>
                </div>
              </div>
            </td>
            <td class="pa-1">
              <el-input v-if="dataValidationItems(form, 'explanation')" v-model="form.explanation" style="width: 100%;" @change="handleAutoSave(i, form)" />
            </td>
            <td class="pa-1 text-center">
              <v-btn color="pink" small fab @click.native="deleteOpen(form, i)">
                <v-icon class="white--text">clear</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import datavalidation from '@/mixins/datavalidation.js'

export default {
  name: 'AnotherCountry',
  props: {
    sectionId: {
      type: String
    },
    sectionLabel: {
      type: String
    },
    sectionInfoBox: {
      type: String
    },
    memberUID: {
      type: String,
      required: true
    },
    memberID: {
      type: String,
      required: true
    },
    isDataValidation: {
      type: Boolean
    }
  },
  mixins: [datavalidation],
  data() {
    return {
      edit: false,
      formItem: {
        application_id: this.$route.params.id,
        member_uid: this.memberUID,
        member_id: parseFloat(this.memberID),
        country: null,
        explanation: null
      },
      url: 'imms_table/application_another_country',
      items: []
    }
  },
  watch: {
    memberUID: function() {
      this.fetchData()
    }
  },
  computed: {
    ...mapGetters({
      country: 'other/country',
      form: 'citizenship/get'
    })
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.$Progress.start()
      this.$store.dispatch('store/get', `table/application_another_country?filter=member_uid=${this.memberUID}`)
        .then(response => {
          let vm = this
          if (vm.isDataValidation) {
            response.resource.forEach(function(item) {
              var form = {
                country: null,
                explanation: null
              }

              var obj = vm.checkFormItems(item, form)

              if (obj != 'empty') {
                vm.items.push(item)
              }
            })

            if (vm.form.another_country === 'No') {
              vm.hideSection = false
            }
            else if (response.resource.length == 0) {
              vm.hideSection = true
            }
            else {
              vm.hideSection = vm.validationItems.length == 0 ? false : true
            }
          }
          else {
            vm.items = response.resource
          }
          this.$Progress.finish()
        })
        .catch(err => {
          this.$Progress.fail()
        })
    },
    checkCitizenship() {
      this.$store.dispatch('citizenship/edit', this.form)
        .then(response => {
          this.$store.dispatch('toaster/add', { text: 'Updated', type: 'success' })
        })
        .catch(err => {
          this.$store.dispatch('toaster/add', { text: 'Disabled', type: 'success' })
        })
    },
    nodeClear() {
      this.formItem = {
        application_id: this.$route.params.id,
        member_uid: this.memberUID,
        member_id: parseFloat(this.memberID),
        country: null,
        explanation: null
      }
      this.edit = false
    },
    saveForm() {
      this.nodeClear()
      this.edit = false
      this.items.push(this.formItem)
    },
    resetForm() {
      this.$refs.form.resetFields()
      this.nodeClear()
    }
  }
}
</script>
